import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, ListItemText } from "@mui/material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import html2canvas from 'html2canvas';
import { LoadingButton } from "@mui/lab";
import { isArray } from "lodash";

export default function IssuesListDialog({ open, description, issues = [], errorLable, onClose }) {
    const { t } = useTranslation()
    const printRef = React.useRef();
    const [loading, setLoading] = useState(false)
    const handleDownloadImage = async () => {
        setLoading(true)
        const element = printRef.current;

        const canvas = await html2canvas(element)
        const data = canvas.toDataURL({ format: 'jpeg', });
        const link = document.createElement('a');

        if (typeof link.download === 'string') {
            link.href = data;
            link.download = 'image.jpg';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(data);
        }
        setLoading(false)
    }
    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            aria-labelledby="alert-issues-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >
            <Box ref={printRef}>
                <DialogTitle id="alert-dialog-title" sx={{ pb: 0, letterSpacing: 'normal' }}>
                    {t("Review orders' issues")}
                </DialogTitle>
                <DialogContent sx={{ py: 0 }}>
                    {description}
                </DialogContent>
                <Divider />
                <DialogContent sx={{ py: 0 }}>
                    <List dense>
                        {issues.map(issue => (
                            <ListItem key={issue?.orderNumber ?? issue?.taskNumber}>
                                <ListItemText
                                    primary={`${t(errorLable)} ${issue?.orderNumber ?? issue?.taskNumber}`}
                                    primaryTypographyProps={{ sx: { letterSpacing: 'normal' } }}
                                    secondaryTypographyProps={{ component: 'ul', ml: 3 }}
                                    secondary={
                                        <>
                                            {
                                                (!!issue?.errors && isArray(issue?.errors)) &&
                                                <ul style={{ listStyleType: 'none' }}>
                                                    {issue?.errors?.map(error => (<li style={{ letterSpacing: 'normal' }} key={error}>{t(error)}</li>))}
                                                </ul>
                                            }

                                            {!!issue?.errorMsg && <li style={{ letterSpacing: 'normal' }}>{t(issue?.errorMsg)}</li>}
                                        </>

                                    }
                                />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Box>
            <Divider />
            <DialogActions>
                <Box mr="auto" />
                <Button
                    sx={{
                        textTransform: "none",
                    }}
                    variant='contained'
                    color='main'
                    onClick={onClose}
                >
                    {t("Close")}
                </Button>
                <LoadingButton
                    variant='contained'
                    sx={{
                        textTransform: "none",
                    }}
                    loading={loading}
                    onClick={handleDownloadImage}>
                    {t("Download")}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}